import Swal from "sweetalert2";
import request from "./Helpers/API";

let mensajes = [];
let listeners = new Set();
let initialized = false;
let loadingPromise = null;

export function addMensajeWhatsapp(msg) {
    mensajes = [msg, ...mensajes];
    listeners.forEach(l => l(mensajes));
}

export function subscribeWhatsapp(listener) {
    listeners.add(listener);
    listener(mensajes);

    return () => listeners.delete(listener);
}

export function getMensajesWhatsapp() {
    return mensajes;
}

export function clearMensajesWhatsapp() {
    mensajes = [];
    listeners.forEach(l => l(mensajes));
}

export async function loadMensajesWhatsapp(force = false) {
    // 🚫 evitar recarga innecesaria
    if (initialized && !force) return;

    // 🚫 evitar múltiples llamadas simultáneas
    if (loadingPromise && !force) return loadingPromise;

    loadingPromise = request
        .get(`NotificacionesWhatsapp/obtenerNotificaciones`)
        .then((result) => {
            mensajes = result || [];
            initialized = true;
            listeners.forEach(l => l(mensajes));
        })
        .catch((error) => {
            Swal.fire(
                "Error cargando notificaciones WhatsApp",
                JSON.stringify(error),
                "error"
            );
        })
        .finally(() => {
            loadingPromise = null;
        });

    return loadingPromise;
}

export function removeMensajeWhatsapp(id) {
    mensajes = mensajes.filter(m => m.idMensaje !== id);
    listeners.forEach(l => l(mensajes));
}

export function resetWhatsappStore() {
    mensajes = [];
    initialized = false;
    loadingPromise = null;
    listeners.forEach(l => l(mensajes));
}